import React, { useEffect } from "react";
import { DataTable } from "../../Components/DataTable";
import { todaysRvColumns } from "./tableConfig";
import { useRvs } from "../../hooks/useRv";

export const TodaysRvsTab: React.FC = () => {
  const { dayRvs, isDayLoading, fetchByDay } = useRvs();

  useEffect(() => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    
    fetchByDay(`${year}-${month}-${day}`);
  }, [fetchByDay]);

  return (
    <section className="mt-10 bg-white p-6 rounded-xl shadow-sm">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold capitalize">Ραντεβού Σήμερα</h2>
      </div>
      <DataTable columns={todaysRvColumns} data={dayRvs} loading={isDayLoading} />
    </section>
  );
};